import type { ImageSizesProps, ImageSourcesProps } from '../modernBlocks/modernBlocks.state'

export const dummyData = {
  title: 'Leo eget bibendum sodales, augue velit cursus nunc',
  intro: 'Quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Leo eget bibendum sodales, augue velit cursus nunc',
  wysiwyg: `<p>Quis gravida magna mi a libero. Fusce vulputate <a href="">eleifend sapien</a>. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.</p>
  <p>Nullam accumsan lorem in dui. Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla.</p>`,
  primaryButton: {
    kind: 'link' as const,
    isLinkExternal: false,
    target: '_self' as const,
    title: 'Primary button',
    url: '#',
  },
  secondaryButton: {
    kind: 'link' as const,
    isLinkExternal: false,
    target: '_self' as const,
    title: 'Secondary button',
    url: '#',
  },
  typography: `
  <p>Tellus eget condimentum rhoncus, <a href='/'>sem quam semper libero</a>, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante <em>tincidunt tempus</em>. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt.</p>
  <h3>H3 Vestibulum ante itae sapien ut libero</h3>
  <p>Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla.</p>
  <ul>
    <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
    <li>Aenean lacinia bibendum nulla sed consectetur.</li>
    <li>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</li>
    <li>Nullam quis risus eget urna mollis ornare vel eu leo.</li>
  </ul>
  <h4>H4 A pharetra augue itae sapien ut libero venenatis</h4>
  <p>Consectetuer adipiscing elit. Integer consequat sapien a lectus gravida euismod. Sed vitae nisl non odio viverra accumsan. Curabitur nisi neque, egestas sed, vulputate sit amet, luctus vitae, dolor. Cras lacus massa, sagittis ut, volutpat consequat, interdum a, nulla</p>
  <ol>
    <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
    <li>Aenean lacinia bibendum nulla sed consectetur.</li>
    <li>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</li>
    <li>Nullam quis risus eget urna mollis ornare vel eu leo.</li>
  </ol>
  <h5>H5 Tincidunt tempus itae sapien ut</h5>
  <p>Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, <a href='/'>sem quam semper libero</a>, sit <b>amet</b> adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem.
  Maecenas nec odio et ante <em>tincidunt tempus</em>.</p>
  <h6>H6 Hendrerit fringilla quis risus eget urna mollis ornare vel</h6>
  <p>Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero.</p> 
`,
  quote:
    'Everyone wants to live on top of the mountain, but all the happiness and growth occurs while you are climbing it.',
  person: 'Jane Fonda',
  personEmail: 'jane@fonda.com',
  personFunction: 'CEO',
  personLinkedIn: 'http://linkedin.com',
  personPhone: '0623456789',
  date: '27 juli 2022',
  video: 'https://www.youtube.com/embed/uH78GUo2TOs',
  image: {
    originalImageUrl: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-512x384.jpeg',
    altText: 'Northern lights',
    source: 'Getty Images',
    imageSizes: [
      {
        style: '656w_webp',
        width: '656',
        height: undefined,
        url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-512x384.jpeg',
      },
      {
        style: '1312w_webp',
        width: '1312',
        height: undefined,
        url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-1024x768.jpeg',
      },
      {
        style: '2624w_webp',
        width: '2624',
        height: undefined,
        url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-2048x1536.jpeg',
      },
    ],
  } as ImageSizesProps['image'],
  imageSources: [
    {
      imageProportions: {
        width: '400',
        height: '225',
        sizes: 'auto',
        media: '(min-width: 768px)',
      },
      image: {
        originalImageUrl: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-512x384.jpeg',
        altText: 'Heart made from dust',
        source: 'Unsplash',
        imageSizes: [
          {
            style: '656w_webp',
            width: '656',
            height: undefined,
            url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-512x384.jpeg',
          },
          {
            style: '1312w_webp',
            width: '1312',
            height: undefined,
            url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-1024x768.jpeg',
          },
        ]
      },
    }
  ] as ImageSourcesProps['sources'],
  image_fallback: {
    originalImageUrl: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-1024x768.jpeg',
    altText: 'Northern lights',
    source: 'Getty Images',
    imageSizes: [
      {
        style: '1312w_webp',
        width: '1312',
        height: undefined,
        url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-1024x768.jpeg',
      },
    ],
  } as ImageSizesProps['image'],
}

export const randomTitle = () => {
  const titles = [
    'Leo eget bibendum sodales, augue velit cursus nunc',
    'Dolor Venenatis Sollicitudin Mollis',
    'Venenatis Porta',
    'Nullam id dolor id nibh ultricies vehicula',
    'Quis gravida magna mi a libero',
    'Nemo enim ipsam voluptatem quia voluptas sit aspernatur',
    'Quis autem vel eum iure reprehenderit',
    'Voluptas nulla pariatur',
  ]

  return titles[Math.floor(Math.random() * titles.length)]
}

export const randomWords = () => {
  const words = [
    'Leo eget',
    'Bibendum',
    'Sodales',
    'Augue velit',
    'Cursus nunc',
    'Dolor Venenatis',
    'Sollicitudin',
    'Mollis',
    'Venenatis Porta',
    'Nullam nibh',
    'Ultricies vehicula',
    'Quis gravida',
    'Magna libero',
    'Nemo enim ipsam',
    'Voluptatem quia',
    'Voluptas sit',
    'Apernatur',
    'Quis autem',
    'Vel eum iure',
    'Reprehenderit',
    'Voluptas',
    'Nulla pariatur',
  ]

  return words[Math.floor(Math.random() * words.length)]
}

export const randomNumber = (min?: number, max?: number) => {
  min = min ? Math.ceil(min) : 0
  max = max ? Math.floor(max) : 2022
  return Math.floor(Math.random() * (max - min) + min)
}

export const randomWysiwygText = () => {
  const texts = [
    `<p>Quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.</p>
     <p>Nullam accumsan lorem in dui. Leo eget bibendum sodales, <a href='#'>augue velit cursus nunc</a>. Iste natus error sit voluptatem accusantium.</p>`,
    `<p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis </p>
     <p>Nemo enim ipsam voluptatem quia voluptas <a href='#'>sit aspernatur aut odit</a> aut fugit. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id.</p>`,
    `<p>Ut enim ad minima veniam, quis <a href='#'>nostrum exercitationem ullam</a> corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur.</p>
     <p>Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur.</p>`,
  ]

  return texts[Math.floor(Math.random() * texts.length)]
}

export const randomWysiwygList = () => {
  const texts = [
    `<ul>Quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.</li>
     <li>Nullam accumsan lorem in dui. Leo eget bibendum sodales, augue velit cursus nunc. Iste natus error sit voluptatem accusantium.</li></ul>`,
    `<ol>Quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.</li>
     <li>Nullam accumsan lorem in dui. Leo eget bibendum sodales. Augue velit cursus nunc. Iste natus error sit voluptatem accusantium.</li></ol>`,
    `<ul>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis </li>
     <li>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id.</li></ul>`,
    `<ol>Quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.</li>
     <li>Nullam accumsan lorem in dui. Leo eget bibendum sodales. Augue velit cursus nunc. Iste natus error sit voluptatem accusantium.</li></ol>`,
    `<ul>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur.</li>
     <li>Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur.</li></ul>`,
  ]

  return texts[Math.floor(Math.random() * texts.length)]
}

export const randomCaption = () => {
  const captions = [
    'Quis gravida magna mi a libero. Fusce vulputate eleifend sapien.',
    'Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
    'Nullam accumsan lorem in dui. Leo eget bibendum sodales, augue velit cursus nunc',
    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis',
    'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit',
    'Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur',
    'Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur',
  ]

  return captions[Math.floor(Math.random() * captions.length)]
}
